export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref14829.89cf6f22.jpg";